import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';

import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VDialog, {
    style: {
      zIndex: _vm.options.zIndex
    },
    attrs: {
      persistent: "",
      "max-width": "90%"
    },
    on: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.close.apply(null, arguments);
      }
    },
    model: {
      value: _vm.shown,
      callback: function callback($$v) {
        _vm.shown = $$v;
      },
      expression: "shown"
    }
  }, [_c(VCard, [_c("div", {
    staticClass: "dialog-closer"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle",
    on: {
      click: function click($event) {
        return _vm.close();
      }
    }
  })], 1), _c(VCardTitle, {
    staticClass: "headline"
  }, [_c("span", {
    staticClass: "text-h5"
  }, [_vm._v("Manage suppliers")])]), _c("div", {
    staticClass: "px-3 mb-3 d-flex gap-2 justify-end"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn secondary --small-2",
    attrs: {
      rounded: "",
      disabled: _vm.isAnyActionPending
    },
    on: {
      click: _vm.openNewSupplierDialog
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-plus mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" New supplier ")], 1)], 1), _c("div", {
    staticClass: "px-3 mb-3"
  }, [_c(VTextField, {
    staticClass: "v-text-field-no-label",
    attrs: {
      autofocus: "",
      placeholder: "Filter suppliers",
      "hide-details": "auto"
    },
    model: {
      value: _vm.search,
      callback: function callback($$v) {
        _vm.search = $$v;
      },
      expression: "search"
    }
  })], 1), _c(VDataTable, {
    staticClass: "elevation-2",
    attrs: {
      headers: _vm.headers,
      items: _vm.gettingSuppliers.results,
      loading: _vm.gettingSuppliers.isPending,
      "loading-text": "Loading... Please wait",
      "hide-default-footer": "",
      "items-per-page": -1,
      "disable-sort": "",
      search: _vm.search
    },
    scopedSlots: _vm._u([{
      key: "item.status",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [item.deleted ? _c("div", {
          staticClass: "badge danger"
        }, [_vm._v("Deleted")]) : _c("div", {
          staticClass: "badge success"
        }, [_vm._v("enabled")])];
      }
    }, {
      key: "item.prices-actions",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c("div", {
          staticClass: "d-flex gap-1 align-center flex-column my-2"
        }, [_c("span", [_vm._v(_vm._s(item.relatedPricesNumber) + " Prices")]), item.relatedPricesNumber > 0 ? _c(VBtn, {
          staticClass: "dfwa-btn secondary --small-2",
          attrs: {
            rounded: "",
            disabled: _vm.isAnyActionPending
          },
          on: {
            click: function click($event) {
              return _vm.confirmDeleteSupplierPrices(item);
            }
          }
        }, [_c(VIcon, {
          staticClass: "fas fa-times-circle mr-1",
          attrs: {
            size: "0.65rem"
          }
        }), _vm._v(" Delete price" + _vm._s(item.relatedPricesNumber > 1 ? "s" : "") + " ")], 1) : _vm._e()], 1)];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c("div", {
          staticClass: "d-flex gap-2"
        }, [!item.deleted ? [_c(VBtn, {
          staticClass: "dfwa-btn secondary --small-2",
          attrs: {
            rounded: "",
            disabled: _vm.isAnyActionPending
          },
          on: {
            click: function click($event) {
              $event.stopPropagation();
              return function () {
                _vm.editSupplier = item;
                _vm.supplierModalShown = true;
              }.apply(null, arguments);
            }
          }
        }, [_c(VIcon, {
          staticClass: "fas fa-pen mr-1",
          attrs: {
            size: "0.65rem"
          }
        }), _vm._v(" Edit ")], 1), _c(VBtn, {
          staticClass: "dfwa-btn secondary --small-2",
          attrs: {
            rounded: "",
            disabled: _vm.isAnyActionPending
          },
          on: {
            click: function click($event) {
              return _vm.confirmDeleteSupplier(item);
            }
          }
        }, [_c(VIcon, {
          staticClass: "fas fa-trash mr-1",
          attrs: {
            size: "0.65rem"
          }
        }), _vm._v(" Delete ")], 1)] : [_c(VBtn, {
          staticClass: "dfwa-btn secondary --small-2",
          attrs: {
            rounded: "",
            disabled: _vm.isAnyActionPending
          },
          on: {
            click: function click($event) {
              return _vm.confirmUndeleteSupplier(item);
            }
          }
        }, [_c(VIcon, {
          staticClass: "fa fa-undo mr-1",
          attrs: {
            size: "0.65rem"
          }
        }), _vm._v(" Reactivate ")], 1)]], 2)];
      }
    }], null, true)
  })], 1), _vm.supplierModalShown ? _c("SupplierDialog", {
    attrs: {
      shown: _vm.supplierModalShown,
      countries: _vm.gettingCountries.countries,
      states: _vm.gettingCountries.states,
      supplier: _vm.editSupplier
    },
    on: {
      save: _vm.saveSupplier,
      close: _vm.closeNewSupplierDialog
    }
  }) : _vm._e(), _c("Confirm", {
    ref: "confirm"
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };